import React, { Suspense } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./index.css";

import PersistProvider from "./providers/persist-provider";
import ReactQueryProvider from "./providers/react-query-provider";
import ReduxProvider from "./providers/redux-provider";
import Loader from "components/Loader";

const container = document.getElementById("root");
const root = createRoot(container!);

const LazyApp = React.lazy(() => import("./App"));

root.render(
  <ReactQueryProvider>
    <ReduxProvider>
      <PersistProvider>
        <BrowserRouter>
          <Suspense fallback={<div className="flex w-screen h-screen items-center justify-center"><Loader /></div>}>
            <LazyApp />
          </Suspense>
        </BrowserRouter>
      </PersistProvider>
    </ReduxProvider>
  </ReactQueryProvider>
);
